import { useQuery } from '@tanstack/react-query';

import { getBetaFreePeriod } from '@/api/beta-free-period';
import { landingKeys } from '@/lib/queryKeys';

function useBetaFreePeriodQuery() {
  return useQuery({
    queryKey: landingKeys.betaFreePeriod,
    queryFn: getBetaFreePeriod,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

/** 베타 무료 종료일(진행 중일 때만 값) — 메인 히어로 공지(specs/036 FR-010). */
export function useBetaFreeUntil(): null | string {
  return useBetaFreePeriodQuery().data?.betaFreeUntil ?? null;
}

/**
 * 요금제 노출 여부 — 베타 무료 기간 중에는 요금제(랜딩 섹션·헤더 메뉴)를 숨기고 가입 유도에 집중한다.
 * BO 베타 무료 설정 하나로 켜고 끄며, 기간이 끝나면 배포 없이 다시 보인다. 판단 SSoT 는 이 훅 하나.
 * 조회 중에는 숨겨 깜빡임을 막고, 조회 실패 시에는 평소대로 보인다.
 */
export function usePricingVisible(): boolean {
  const { data, isPending, isError } = useBetaFreePeriodQuery();
  if (isError) return true;
  if (isPending) return false;
  return data.betaFreeUntil == null;
}
